import { greenText, pinkText, redText } from './common.styles';

const MS_IN_A_DAY = 86_400_000; // milliseconds in one day
const EXPIRY_WARNING_DAYS = 30; // threshold for "expires soon"

export const getCreditStatus = (expiresAt?: string): { type: string; label: string } => {
  if (!expiresAt) return { type: 'success', label: 'Valid' };

  const expirationDate = new Date(expiresAt);

  // Invalid date
  if (Number.isNaN(expirationDate.getTime())) return { type: 'error', label: 'Expired' };

  const timeDiff = expirationDate.getTime() - Date.now();

  // Past date
  if (timeDiff <= 0) return { type: 'error', label: 'Expired' };

  const daysUntilExpiration = Math.ceil(timeDiff / MS_IN_A_DAY);

  // Within warning threshold
  if (daysUntilExpiration <= EXPIRY_WARNING_DAYS) return { type: 'warning', label: 'Expires soon' };

  // Otherwise valid
  return { type: 'success', label: 'Valid' };
};
// Credits are in $dollar
export const getCreditBalanceColorClass = (creditBalanceRaw: number, minCredit: number = 5, recommendedCredit: number = 10): string => {
  const balanceInDollars = creditBalanceRaw / 100;

  if (balanceInDollars < minCredit) {
    return redText;
  } else if (balanceInDollars <= recommendedCredit) {
    return pinkText;
  } else {
    return greenText;
  }
};
